import { IUserTokenDto } from "../../../interfaces/user/IUserTokenDto";
import { updateSessionStoreWithUserInformation } from "../session";
import { extractToken } from "../token";

export default function updateUserInformation(response: IUserTokenDto) {
    const token = response?.token;
    const userToken = extractToken(token);

    updateSessionStoreWithUserInformation(token, userToken);
}